import {
    SearchClient
} from "../clients/SearchClient"


export const SearchModule = {
    namespaced: true,

    state: {
        results: Object,
        displaySearchBar: false,
        searching: false,
        topicId: null,
        navigate: false,
        lessonSearchTerm: null
    },

    mutations: {
        SET_TOPIC_ID(state, payload) {
            state.topicId = payload
        },
        COMMIT_RESULTS(state, payload) {
            state.results = payload
        },
        TOGGLE_DISPLAY(state) {
            state.displaySearchBar = !state.displaySearchBar
        },
        TOGGLE_SEARCHING(state, payload) {
            state.searching = payload
        },
        SET_NAVIGATE(state, payload) {
            state.navigate = payload
        },
        SET_DISPLAY(state, payload) {
            state.displaySearchBar = payload
        },
        SET_LESSON_TERM(state, payload) {
            state.lessonSearchTerm = payload
        }

    },

    actions: {
        setLessonTerm({
            commit
        }, payload) {
            commit('SET_LESSON_TERM', payload)
        },
        setNavigate({
            commit
        }, payload) {
            commit('SET_NAVIGATE', payload)
        },
        setTargetTopic({
            commit
        }, payload) {
            commit('SET_TOPIC_ID', payload)

        },
        setDisplay({
            commit
        }, payload) {
            commit("SET_DISPLAY", payload)
        },
        toggleDisplay({
            commit
        }) {
            commit("TOGGLE_DISPLAY")
        },
        sendSearch({
            commit
        }, payload) {
            commit('TOGGLE_SEARCHING', true)
            SearchClient.search(payload).then((response) => {
                commit("COMMIT_RESULTS", response.data.result)
                commit('TOGGLE_SEARCHING', false)
            }).catch((err) => {
                commit('TOGGLE_SEARCHING', false)

            })
        }
    }
};